import { ChevronRight } from "lucide-react";

import type { DisplayLoyaltyTier } from "@/api/orval/model";
import { useTranslation } from "@/core/i18n";

import { LoyaltyTierBadge } from "./LoyaltyTierBadge";

type LoyaltyTierChipProps = {
  tier: DisplayLoyaltyTier;
  onClick: () => void;
};

/** The patient's tier as a pill beside the greeting, opening their status page. */
export const LoyaltyTierChip = ({ tier, onClick }: LoyaltyTierChipProps) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      aria-label={t("loyalty.viewTierStatus", { tier: tier.name })}
      className="flex shrink-0 items-center gap-1.5 rounded-full border border-white bg-white/60 py-0.5 pl-0.5 pr-1.5 text-primary transition-colors hover:bg-white"
      onClick={onClick}
    >
      <LoyaltyTierBadge tier={tier} size="xs" />
      <span className="text-body3 font-semibold">{tier.name}</span>
      <ChevronRight aria-hidden className="-ml-0.5 h-3.5 w-3.5" />
    </button>
  );
};
